module.exports = __webpack_public_path__ + "html/onboarding.component.html";